import type { DataType } from '@risksmart-app/shared/reporting/datasets/types';
import type { FC } from 'react';
import { NoWidgetData } from 'src/pages/dashboards/widgets/NoWidgetData';
import { WidgetLoading } from 'src/pages/dashboards/widgets/widget-loading';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import type { DatePrecision, Series } from '../types';
import type { SegmentData } from '../WidgetPieChart';
import { WidgetBarChartCloudscape } from './WidgetBarChart.cloudscape';
import { WidgetBarChartHighcharts } from './WidgetBarChart.highcharts';

export type Props = {
  loading: boolean;
  series: Series[];
  xAxisDataType: DataType;
  xAxisDatePrecision: DatePrecision | null;
  stackedBars?: boolean;
  onSegmentClick?: (data: SegmentData) => void;
};

export const WidgetBarChart: FC<Props> = (props) => {
  const highchartsEnabled = useIsFeatureVisibleToOrg('highcharts');

  if (props.loading) {
    return <WidgetLoading />;
  }

  if (props.series.length === 0) {
    return <NoWidgetData />;
  }

  if (highchartsEnabled) {
    return <WidgetBarChartHighcharts {...props} />;
  }

  return <WidgetBarChartCloudscape {...props} />;
};
